import axios from 'axios';
import { isEmpty } from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import {
  useNavigate,
  useParams,
  useSearchParams,
  createSearchParams,
} from 'react-router';
import qs from 'qs';
import { AssetContext } from 'context';
import { parametersApi, handleApiError } from 'api/index';

export default setFilterCount => {
  const { theAsset } = useContext(AssetContext);
  const { projectId, assetId, parameterId } = useParams();
  const navigate = useNavigate();
  const [parameterWizardOpen, setParameterWizardOpen] = useState(false);
  const [assetsLoading, setAssetsLoading] = useState(true);
  const [assetList, setAssetList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const toggleParameterWizard = () =>
    setParameterWizardOpen(!parameterWizardOpen);
  const { ...parsedSearch } = qs.parse(searchParams.toString());
  const [isStacked, setIsStacked] = useState(false); // State to track layout
  const headerRef = useRef(null); // Ref for the header element

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.contentRect.width < 700) {
          setIsStacked(true); // Stack buttons vertically if width < 600px
        } else {
          setIsStacked(false); // Use horizontal layout otherwise
        }
      }
    });
    const currentRef = headerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  useEffect(() => {
    let didCancel = false;
    const source = axios.CancelToken.source();
    let parents = [];
    setAssetList(parents);
    setAssetsLoading(true);

    const getParentAssets = async () => {
      let parentId = theAsset.parent;
      while (parentId && !didCancel) {
        try {
          const response = await parametersApi(
            'getAsset',
            {
              asset_id: parentId,
              show_deleted: true,
            },
            source.token
          );
          if (!didCancel && response) {
            const { asset: parentAsset } = response;
            parents = [parentAsset, ...parents];
            parentId = parentAsset.parent;
            setAssetList(parents);
          }
        } catch (err) {
          handleApiError(err, []);
        }
      }
      setAssetsLoading(false);
    };

    if (theAsset?.parent) getParentAssets();
    else setAssetsLoading(false);

    return () => {
      didCancel = true;
      source.cancel();
    };
  }, [theAsset, searchParams]);

  useEffect(() => {
    if (!isEmpty(parsedSearch) && setFilterCount) {
      // eslint-disable-next-line no-unused-vars
      const { sort_by, order, ...filtersOnly } = { ...parsedSearch };
      let filtersLength = 0;
      delete filtersOnly.show_deleted_parameters;
      delete filtersOnly.project_parameter;
      delete filtersOnly.show_deleted_assets;
      filtersLength += Object.values(filtersOnly).flatMap(num => num).length;
      setFilterCount(filtersLength);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parsedSearch]);

  const handleSortDirection = () => {
    const search = {
      ...parsedSearch,
      order: parsedSearch.order === 'asc' ? 'desc' : 'asc',
    };
    if (parameterId)
      navigate({
        pathname: assetId
          ? `/projects/${projectId}/asset/${assetId}/parameters`
          : `/projects/${projectId}/parameters`,

        search: `?${createSearchParams(search)}`,
      });
    else setSearchParams(search);
  };

  return {
    handleSortDirection,
    assetsLoading,
    setAssetsLoading,
    assetList,
    setAssetList,
    parameterWizardOpen,
    setParameterWizardOpen,
    toggleParameterWizard,
    parsedSearch,
    isStacked,
    headerRef,
  };
};
